<div
  class="flex items-center justify-end py-2">
<app-back-button></app-back-button>
 
</div><!-- ================= COMMENT INPUT ================= -->

<section  class="bg-white border border-gray-200 rounded-xl p-5 shadow-sm">
  <div class="flex items-center justify-between mb-3 ">
    <label class="flex items-center gap-2 text-sm font-semibold text-gray-800">
      <svg class="w-4 h-4 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
      </svg>
      {{ 'ONB_REVIEW.ADD_A_COMMENT' | translate }}
    </label>
    <span class="text-xs text-gray-400">
      {{ comment.length }} / 500
    </span>
  </div>

  <div class="relative">
    <textarea
      [(ngModel)]="comment"
      rows="4"
      maxlength="500"
      [placeholder]="'ONB_REVIEW.COMMENT_PLACEHOLDER' | translate"
      class="w-full border bg-gray-50 border-gray-200 rounded-lg p-3 text-sm text-gray-700 placeholder-gray-400
             focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 focus:bg-white
             transition-all duration-200 resize-none outline-none
             disabled:bg-gray-100 disabled:cursor-not-allowed"
      [readonly]="isViewMode"
      [disabled]="isSubmitting || isViewMode">
    </textarea>
  </div>

  <div class="flex items-center justify-between mt-2">
    <p class="text-xs text-gray-400 flex items-center gap-1">
      <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      {{ 'ONB_REVIEW.COMMENT_VISIBLE_NOTE' | translate }}
    </p>
  </div>
</section>

<!-- ================= COMMENTS LIST ================= -->

<div class="mt-6">

  <!-- Header -->
  <div class="flex items-center justify-between mb-4">
    <h3 class="text-sm font-semibold text-gray-800 flex items-center gap-2">
      <svg class="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
      </svg>
      {{ 'ONB_REVIEW.REVIEW_HISTORY' | translate }}
      <span class="bg-indigo-100 text-indigo-700 text-xs font-medium px-2 py-0.5 rounded-full">
        {{ comments.length }}
      </span>
    </h3>
  </div>

  <!-- Timeline -->
  <div class="relative space-y-4">

    <!-- Vertical line -->
    @if (comments.length > 0) {
      <div
        class="absolute start-5 top-2 bottom-2 w-0.5 bg-gradient-to-b from-indigo-200 via-gray-200 to-transparent">
      </div>
    }

    @for (item of comments; track item; let i = $index) {
      <div
        class="relative ps-14">

        <!-- Avatar circle -->
        <div class="absolute start-0 top-0 w-10 h-10 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600
                    flex items-center justify-center text-white text-sm font-semibold shadow-md ring-4 ring-white">
          {{ (item.crtdBy || '?').charAt(0).toUpperCase() }}
        </div>

        <!-- Card -->
        <div class="bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-200">

          <!-- Card Header -->
          <div class="flex items-start justify-between p-4 border-b border-gray-100">
            <div class="flex-1 min-w-0">
              <div class="flex items-center gap-2 flex-wrap">
                <span class="font-semibold text-gray-900 text-sm">
                  {{ item.crtdBy }}
                </span>
                <span class="inline-flex items-center gap-1 bg-indigo-50 text-indigo-700 text-xs font-medium px-2 py-0.5 rounded-full">
                  <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                  {{ item.rvwrRl | translate }}
                </span>
              </div>
              <p class="text-xs text-gray-500 mt-1 flex items-center gap-1">
                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span dir="ltr">{{ item.crtdDt | date:'medium' }}</span>
              </p>
            </div>

            <!-- Sequence badges -->
            <div class="flex flex-col items-end gap-1 ms-3 shrink-0">
              <span class="text-[10px] font-medium text-gray-500 bg-gray-100 px-2 py-0.5 rounded">
                RVW #{{ item.rvwSeq }}
              </span>
              <span class="text-[10px] font-medium text-gray-500 bg-gray-100 px-2 py-0.5 rounded">
                ONB #{{ item.onbrdngSeq }}
              </span>
            </div>
          </div>

          <!-- Card Body -->
          <div class="p-4">
            <p class="text-sm text-gray-700 leading-relaxed whitespace-pre-line">
              {{ item.cmmnt }}
            </p>
          </div>
        </div>
      </div>
    }

    <!-- EMPTY STATE -->
    @if (comments.length === 0) {
      <div
        class="bg-gradient-to-br from-gray-50 to-gray-100 border-2 border-dashed border-gray-300 rounded-xl p-10 text-center">

        <div class="inline-flex items-center justify-center w-14 h-14 rounded-full bg-white shadow-sm mb-3">
          <svg class="w-7 h-7 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
              d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
          </svg>
        </div>
        <p class="text-sm font-semibold text-gray-700">
          {{ 'ONB_REVIEW.NO_COMMENTS_YET' | translate }}
        </p>
        <p class="text-xs text-gray-500 mt-1">
          {{ 'ONB_REVIEW.BE_FIRST_TO_COMMENT' | translate }}
        </p>
      </div>
    }
  </div>
</div>

<!-- ================= FOOTER ================= -->

<div
  class="flex items-center justify-start gap-3 mt-8 pt-5 border-t border-gray-200"
  >

  @if (!isViewMode) {
    <button
      class="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-gradient-to-r from-indigo-600 to-indigo-700
             text-white text-sm font-semibold shadow-sm
             hover:from-indigo-700 hover:to-indigo-800 hover:shadow-md
             focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2
             disabled:opacity-50 disabled:cursor-not-allowed
             transition-all duration-200"
      (click)="forward()"
      [disabled]="isSubmitting">

      <ng-container>
        <span>{{ 'COMMON.SUBMIT' | translate }}</span>
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M14 5l7 7m0 0l-7 7m7-7H3" />
        </svg>
      </ng-container>
    </button>
  }
</div>